import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { getAllReceiptSettingsPayload, ReceiptSettingsPayload, ReceiptUpdateResponse, ReceiptValueItem, ReceiptValueResponse } from "../../components/settings/receiptSettings.module";

interface initialState {
    getAllReceiptSettings: { loading: boolean, value: ReceiptValueItem[] | null, error: string | null, }
    updateReceiptSettings: { loading: boolean, value: ReceiptUpdateResponse | null, error: string | null, }
}
const initialState: initialState = {
    getAllReceiptSettings: { loading: false, value: null, error: null, },
    updateReceiptSettings: { loading: false, value: null, error: null, },
}

export const getAllReceiptSettings = createAsyncThunk("receiptSettings/getAllReceiptSettings", ({ storeId, receiptType }: getAllReceiptSettingsPayload) => {
    const url = HttpRoutingService?.replaceUrl(API?.receiptSettings, { storeId })
    return HttpRoutingService?.getMethod<ReceiptValueResponse>(url, { receiptType })
})

export const updateReceiptSettings = createAsyncThunk("receiptSettings/updateReceiptSettings", ({ storeId, data }: ReceiptSettingsPayload) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateReceiptSettings, { storeId })
    return HttpRoutingService?.putMethod<ReceiptUpdateResponse>(url, data, undefined, "v2/")
})

export const receiptSettingsSlice = createSlice({
    name: "receiptSettings",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllReceiptSettings?.pending, (state) => {
                state.getAllReceiptSettings.loading = true
            })
            .addCase(getAllReceiptSettings?.fulfilled, (state, action) => {
                state.getAllReceiptSettings.loading = false
                state.getAllReceiptSettings.value = action.payload?.receiptValueData
                state.getAllReceiptSettings.error = null
            })
            .addCase(getAllReceiptSettings?.rejected, (state, action) => {
                state.getAllReceiptSettings.loading = false
                state.getAllReceiptSettings.error = action?.error?.message as string
            })
            .addCase(updateReceiptSettings?.pending, (state) => {
                state.updateReceiptSettings.loading = true
            })
            .addCase(updateReceiptSettings?.fulfilled, (state, action) => {
                state.updateReceiptSettings.loading = false
                state.updateReceiptSettings.value = action.payload
                state.updateReceiptSettings.error = null
            })
            .addCase(updateReceiptSettings?.rejected, (state, action) => {
                state.updateReceiptSettings.loading = false
                state.updateReceiptSettings.error = action?.error?.message as string
            })
    }
})

export default receiptSettingsSlice?.reducer